<script>

import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['rawData', 'rangeDate'],
  name: 'UserActivity',
  data () {
    return {
      options: {
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            type: 'time',
            distribution: 'series',
            ticks: {
              source: 'data',
              autoSkip: true
            },
            time: {
              unit: 'day',
              distribution: 'series',
              displayFormats: {
                quarter: 'll'
              },
              ticks: {
                source: 'auto'
              }
            }
          }],
          yAxes: [{
            scaleLabel: {
              display: false
            },
            ticks: {
              beginAtZero: true
            }
          }]
        },
        tooltips: {
          intersect: false,
          mode: 'index'
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      },
      data: {
        datasets: [{
        }],
        labels: []
      }
    }
  },
  watch: {
    'rawData.projects' () {
      this.draw()
    },
    'rawData.login' () {
      this.draw()
    },
    'rawData.searches' () {
      this.draw()
    }
  },
  methods: {
    draw: function () {
      this.data = {
        datasets: [{
        }],
        labels: []
      }

      let projectsUsersValue = []
      let loginUsersValue = []
      let searchUsersValue = []
      let newUsersValue = []
      let shareProjectValue = []
      let shareDocumentValue = []

      let startDate = this.$moment(this.rangeDate.start)
      let interval = this.rawData.interval
      this.options.scales.xAxes[0].time.unit = interval
      let endDate = this.$moment(this.rangeDate.end)

      startDate = startDate.clone().subtract(1, interval)
      endDate = endDate.isAfter(this.$moment(), interval) ? this.$moment().format('YYYY-MM-DD') : endDate

      while (startDate.diff(this.$moment(endDate), interval)) {
        startDate = startDate.clone().add(1, interval)

        projectsUsersValue.push({x: startDate, y: 0})
        loginUsersValue.push({x: startDate, y: 0})
        searchUsersValue.push({x: startDate, y: 0})
        newUsersValue.push({x: startDate, y: 0})
        shareProjectValue.push({x: startDate, y: 0})
        shareDocumentValue.push({x: startDate, y: 0})
      }

      projectsUsersValue.forEach((value) => {
        this.rawData.projects.forEach((user) => {
          let date = this.$moment(user.created_at)
          if (date.isSame(value.x, interval) === true) {
            value.y = user.total
          }
        })
      })

      loginUsersValue.forEach((value) => {
        this.rawData.login.forEach((user) => {
          let date = this.$moment(user.login_at)
          if (date.isSame(value.x, interval) === true) {
            value.y = user.total
          }
        })
      })

      searchUsersValue.forEach((value) => {
        this.rawData.searches.forEach((user) => {
          let date = this.$moment(user.created_at)
          if (date.isSame(value.x, interval) === true) {
            value.y = user.total
          }
        })
      })

      newUsersValue.forEach((value) => {
        this.rawData.users.forEach((user) => {
          let date = this.$moment(user.created_at)
          if (date.isSame(value.x, interval) === true) {
            value.y = user.total
          }
        })
      })
      shareProjectValue.forEach((value) => {
        this.rawData.shareProject.forEach((share) => {
          let date = this.$moment(share.shared_at)
          if (date.isSame(value.x, interval) === true) {
            value.y = share.total
          }
        })
      })
      shareDocumentValue.forEach((value) => {
        this.rawData.shareDocument.forEach((share) => {
          let date = this.$moment(share.shared_at)
          if (date.isSame(value.x, interval) === true) {
            value.y = share.total
          }
        })
      })

      this.data.datasets = [
        {
          label: 'Connections',
          data: loginUsersValue,
          fill: false,
          backgroundColor: 'rgba(98, 203, 49, 0.8)',
          borderColor: 'rgba(98, 203, 49, 0.8)'
        }, {
          label: 'New Users',
          data: newUsersValue,
          fill: false,
          backgroundColor: 'rgba(52, 152, 219, 0.8)',
          borderColor: 'rgba(52, 152, 219, 0.8)'
        }, {
          label: 'Searches',
          data: searchUsersValue,
          fill: false,
          backgroundColor: 'rgba(255, 182, 6, 0.8)',
          borderColor: 'rgba(255, 182, 6, 0.8)'
        }, {
          label: 'New Projects',
          data: projectsUsersValue,
          fill: false,
          backgroundColor: 'rgba(231, 76, 60, 0.8)',
          borderColor: 'rgba(231, 76, 60, 0.8)'
        }, {
          label: 'Share Project',
          data: shareProjectValue,
          fill: false,
          backgroundColor: 'rgba(155,89,182,1)',
          borderColor: 'rgba(155,89,182,1)',
          hidden: true
        }, {
          label: 'Share Document',
          data: shareDocumentValue,
          fill: false,
          backgroundColor: 'rgba(52,73,94,1)',
          borderColor: 'rgba(52,73,94,1)',
          hidden: true
        }
      ]
      this.renderChart(this.data, this.options)
    }
  },
  mounted () {
    this.draw()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/UserActivity.vue